exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "#walletWidgetDiv[data-v-5a5262fc] {\n  height: 270px;\n  padding: 0.1em;\n}\n", ""]);

// exports
